import { useEffect, useState } from 'react';
import { supabase } from '../../../lib/supabase';
import type { MachineTemplate } from '../types';
import { attachMachineTemplateOptionsAndSpecifications, MACHINE_TEMPLATE_SELECT } from './machineTemplateQueries';

interface UseMachineTemplatesReturn {
  templates: MachineTemplate[];
}

export function useMachineTemplates(orgId: string | null): UseMachineTemplatesReturn {
  const [templates, setTemplates] = useState<MachineTemplate[]>([]);

  useEffect(() => {
    if (!orgId) {
      setTemplates([]);
      return;
    }
    const load = async () => {
      try {
        const { data } = await supabase
          .from('machine_templates')
          .select(MACHINE_TEMPLATE_SELECT)
          .eq('organization_id', orgId)
          .eq('archived', false)
          .order('name');
        setTemplates(await attachMachineTemplateOptionsAndSpecifications((data ?? []) as unknown as MachineTemplate[]));
      } catch {
        setTemplates([]);
      }
    };
    load();
  }, [orgId]);

  return { templates };
}
